'use strict';

export default class Signature {

	constructor(role) {
		this.devtools = {
			open: false,
			orientation: null
		};

		this.role = role;

		switch (this.role) {
		case 'Design':
			this.padding = 82;
			break;
		case 'Design & Code':
			this.padding = 56;
			break;
		case 'Code':
			this.padding = 87;
			break;
		default:
			throw 'Please select an appropriate role in the project';
			break;
		}

this.h = [
`              _-o#&&*''''?d:>b|_             
		  _o/"'''  '',, dMF9MMMMMHo_          
	   .o&#'        '"MbHMMMMMMMMMMMHo.       
	 .o"" '         vodM*$&&HMMMMMMMMMM?.     
	,'              $M&ood,~''(&##MMMMMMH|    
   /               ,MMMMMMM#b?#bobMMMMHMMML   
  &              ?MMMMMMMMMMMMMMMMM7MMM$R*Hk  
 ?$.            :MMMMMMMMMMMMMMMMMMM/HMMM|'*L 
|               |MMMMMMMMMMMMMMMMMMMMbMH'   T,
$H#:            '*MMMMMMMMMMMMMMMMMMMMb#}'  '?
]MMH#             ""*""""*#MMMMMMMMMMMMM'    -
MMMMMb_                   |MMMMMMMMMMMP'     :
HMMMMMMMHo                 'MMMMMMMMMT       .
?MMMMMMMMP                  9MMMMMMMM}       -
-?MMMMMMM                  |MMMMMMMMM?,d-    '
 :|MMMMMM-                 'MMMMMMMT .M|.   : 
  .9MMM[                    &MMMMM*' ''    .  
   :9MMk                    'MMM#"        -   
	 &M}                     '          .-    
	  '&.                             .       
		'~,   .                     ./        
			. _                  .-           
			  ''--._,dd###pp=""'              
`,
`              v->#H#P? "':o<>|_              
		  .,dP' '''  "'-o.+H6&MMMHo_          
		oHMH9'         '?&bHMHMMMMMMHo.       
	  oMP"' '           ooMP*#&HMMMMMMM?.     
	,M*          -     '*MSdob//'^&##MMMH|    
   d*'                .,MMMMMMH#o>#ooMMMMMb   
  HM-                :HMMMMMMMMMMMMMMM&HM[R|  
 d"Z|.               9MMMMMMMMMMMMMMMMM[HMM|: 
-H    -              MMMMMMMMMMMMMMMMMMMbMP' :
:??Mb#               '9MMMMMMMMMMMMMMMMMMH#! .
: MMMMH#,              "*""""'#HMMMMMMMMMMH  -
||MMMMMM6|.                    {MMMMMMMMMH'  :
:|MMMMMMMMMMHo                 '9MMMMMMMM'   .
. HMMMMMMMMMMP'                 !MMMMMMMM    '
- '#MMMMMMMMM                   HMMMMMMM*,/  :
 :  ?MMMMMMMF                   HMMMMMM',P' : 
  .  HMMMMR'                    {MMMMP' ^' -  
   : 'HMMMT                     iMMH'     .'  
	-.'HMH                               .    
	  -:*H                            . '     
		-'|,,    .                  .-        
		  ' .  _                 .-'          
			  ''~|.__,obb#q==~'''             
`,
`              .ovr:HMM#?:'' >b|_             
		  .,:&Hi' ''   "' ||&bSMHo_           
		oHMMM#*}          '?&dMMMMMMHo.       
	 .dMMMH"''''           ,oHH*&&9MMMM?.     
	,MMM*'                 '*M|bd<|"*&#MH|    
   dHH?'                   :MMMMMM#bd#odMML   
  H' ||                  'dMMMMMMMMMMMMMM9Mk  
 JL/"7+,.                'MMMMMMMMMMMMMMMH9ML 
-'Hp     '               |MMMMMMMMMMMMMMMMHH|:
:  |#M#d?                'HMMMMMMMMMMMMMMMMH. 
.   JMMMMM##,              '*""'"*#MMMMMMMMH  
-. ,MMMMMMMM6o_                    |MMMMMMMM':
:  |MMMMMMMMMMMMMb|                 TMMMMMMT :
.   ?MMMMMMMMMMMMM'                 :MMMMMM|.'
-    ?HMMMMMMMMMM:                  HMMMMMM||:
 :     9MMMMMMMMH'                 'MMMMMP.P. 
  .    'MMMMMMT''                   HMMM*''-  
   -    TMMMMM'                     MM*'  -   
	'.   HMM#                            -    
	  -. '9M:                          .'     
		-. 'b,,    .                . '       
		  '-|   .,               .-'          
			  '-:b~|_,oddq==--"               
`,
`              _oo##'9MMHb':'-,o_             
		  .oH":HH$' ""'  "' -7*R&o_           
	   .oHMMMHMH#9:          "|bMMMMHo.       
	  dMMMMMM*""'''           .oHM"H9MM?.     
	,MMMMMM'                   "HLbd<|?&H|    
   JMMH#H'                     |MMMMM#b>bHb   
  :MH  ."|                   '|MMMMMMMMMMMM&  
 .:M:d-"|:b..                 9MMMMMMMMMMMMM+ 
:  "*H|      -                &MMMMMMMMMMMMMH:
.    'LvdHH#d?                '?MMMMMMMMMMMMMb
:      iMMMMMMH#b               '"*"'"#HMMMMMM
.   . ,MMMMMMMMMMb|.                   {MMMMMH
-     |MMMMMMMMMMMMMMHb,               'MMMMM|
:      |MMMMMMMMMMMMMMH'                &MMMM,
-       '#MMMMMMMMMMMM                 |MMMM6-
 :        'MMMMMMMMMM+                 ]MMMT/ 
  .       'MMMMMMMP"                   HMM*'  
   -       |MMMMMH'                   ,M#'-   
	'.     :MMMH|                       .-    
	  .     |MM                        -      
	   ' .   '#?..    .             ..'       
		   -.     _.             .-           
			  '-|.#qo__,,ob=~~-''             
`,
`              _ooppH['MMMD::--|_             
		  .oHMMMR:"&MZ| '"'  "  |$-_          
	   ..dMMMMMMMMdMMM#9|        ''HHo.       
	 . ,dMMMMMMMMMMM"'' '           ?MP?.     
	. |MMMMMMMMMMM'                 '"$b&|    
   -  |MMMMHH##M'                     HMMH?   
  -   TTMM|    >..                   |MMMMMH  
 :     |MM|,#-""$~b|.                'MMMMMM+ 
.       '"H&#        -               &MMMMMM| 
:            *|v,#MHddc.              '9MMMMMb
.               MMMMMMMM##|             '"":HM
-          .  .HMMMMMMMMMMRo_.              |M
:             |MMMMMMMMMMMMMMMM#|           :M
-              'HMMMMMMMMMMMMMMM'           |T
:               '*HMMMMMMMMMMMM'            H'
 :                 MMMMMMMMMMM|            |T 
  .                MMMMMMMM?'             ./  
  '.               MMMMMMH'              ./   
	-.            |MMMH#'                .    
	  .           'MM*                . '     
		-.         #M: .    .       .-        
		  ' .         .,         .-           
			  '-.-~ooHH__,,v~--'              
`,
`            _ood>H&H&Z?#M#b-|.               
		  .|HMMMMMR?'|M6b."'' '''v.           
	   .. .MMMMMMMMMMHMMM#&.      '~o.        
	 .   ,HMMMMMMMMMMMM*"'-'          &b.     
	.   .MMMMMMMMMMMMH'               '"&|    
   -     RMMMMM#H##R'                   4Mb   
  -      |7MMM'    ?::                 '|MMb  
 /         HMM__#|'"|>?v..              'MMML 
.           '"'#Hd|       '              9MMM:
-                ||,|?HH#bbL             '9MMb
:                   !MMMMMMMH#b,          '""T
.              .   ,MMMMMMMMMMMbo.           |
:                  4MMMMMMMMMMMMMMMHo        |
:                   ?MMMMMMMMMMMMMMM?        :
-.                   '#MMMMMMMMMMMM:        .-
 :                     |MMMMMMMMMM?         . 
  -                    JMMMMMMMT'          :  
  '.                   MMMMMMH'           -   
	-.                |MMM#*'            -    
	  .               HMH'            . '     
		-.            #H:.          .-        
		  ' .           .|       .-           
			  '-..-+oodHL_,--/-'              
`,
`             _,|?dZkMHF&$*q#b..              
		  .//9MMMMMMM?:'HM|"'-'''..           
	   ..'  :MMMMMMMMMMHMMMMH?_    '-|        
	 .     .dMMMMMMMMMMMMMM'"'"       '|.     
	.      |MMMMMMMMMMMMMR              |     
   -        T9MMMMMHH##M"                '?   
  :          (9MMM'    !':.               &k  
 .:            HMM|_?p "":-b|.            'ML 
-                "'"H&#,       :           |M|
:                     ?|,|dMH#b#.           9b
:                        |MMMMMMM##,        '*
:                   .   +MMMMMMMMMMMo_       -
:                       HMMMMMMMMMMMMMM#,    :
:                        9MMMMMMMMMMMMMH'    .
: .                       *HMMMMMMMMMMP     .'
 :                          MMMMMMMMMH'     . 
  -                        :MMMMMMM''      .  
  '.                       9MMMMM*'       -   
	-.                    {MMM#'         :    
	  -                  |MM"          .'     
	   '.                &M'..  .   ..'       
		  ' .             ._     .-           
			  '-. -voboo#&:,-.-'              
`,
`             _oo:|bk99M[<$$+b|.              
		   .$*"MMMMMMMM[:"|Mb|?^" .           
	   . ''    HMMMMMMMMMMHMMMM+?.  '.        
	 .        .HMMMMMMMMMMMMMMP"''     .      
	.         'MMMMMMMMMMMMMM|         -'.    
   -           '&MMMMMMHH##H:             :   
  :             '(*MMM}    '||             |  
 : '-              ?MMb__#|""'|+v..         | 
.                    '''*H#b       -        :|
:                         '*|v,#M#b#,        |
.                             9MMMMMMHb.     :
:                        .   #MMMMMMMMMb|    -
-                           .HMMMMMMMMMMMMb  :
:                            'MMMMMMMMMMMMH  .
-:  .                         '#MMMMMMMMMP   '
 :                              ]MMMMMMMH'  : 
  -                            ,MMMMMM?'   .  
  ':                           HMMMMH"    -   
	-.                       .HMM#*     .-    
	 '.                     .HH*'     .       
	   '-.                  &R".    .-        
		   -.               ._   .-           
			  '-. .voodoodc?..-'              
`,
`              _|oo|?ddk9MRbS>v|_             
		  ..:>*""MMMMMMMMM:?|H?$?-.           
	   ..- -     "HMMMMMMMMMMHMMMH|_-.        
	 .            dMMMMMMMMMMMMMMT"    .      
	.             TMMMMMMMMMMMMMM       '.    
   -               '&HMMMMMM#H#H:         .   
  -                 '|7HMMH     ||.        .  
 :    '                 HMM|_?c'""+?|..     : 
-                         "'#&#|      .     - 
:                              '?,|#MHdb.    .
:                                 |MMMMMH#.  :
:                            .   ,HMMMMMMMb, -
: '                              4MMMMMMMMMMH'
:   .                             9MMMMMMMMMT-
:.'                               '#MMMMMMMH '
 :      '                           HMMMMMH': 
  -                                |MMMMH" -  
  ':                              |MMMH*' .'  
	'?                           dMM#'   .    
	  |.                       .dH"    .'     
		-.                    ,M'-  ..'       
		  ' .                .. ..-'          
			  '-. .|ooooboo<^.-'              
`,
`              _o,:o?|?dM&MHcc~,.             
		  ..^':&#""HMMMMMMMM$:?&&?.           
		.'  -'      'HMMMMMMMMMHMMMp|.        
	 . '             |MMMMMMMMMMMMMM"' .      
	.                '9MMMMMMMMMMMMM    -.    
   -                   '*9MMMMMHH##[      .   
  -                     '|Z9MMM    '~|     .  
 :       '|                 ?MMb_?p""-?v..  : 
-                             '"'*&#,    -   .
:                                  '?,oHH#?  .
--                                    |MMMMH,:
:                                 .  |MMMMMM6,
:   -                                |MMMMMMMM
?                                     HMMMMMMP
-- . '                                |HMMMMM'
 :.'     .  '                          JMMMM+ 
  |                                   ,MMMP:  
   :                                 |MMH?:   
	-:|.                            dM#" .    
	   |                          ,H*' .'     
		-.                       d':..'       
		  ' .                  .,.-           
			  '-.. .|oooodov~^-'              
`,
`              _o|:,??|??MR9#cb|_             
		  .v/''':&#""#HMMMMMMM$?*d|.          
	   ..~' - -'      '"#MMMMMMMMMMMHv.       
	 .-'                 HMMMMMMMMMMMR!.      
	:                    '9MMMMMMMMMMM| -.    
   .                       '*9MMMMMH##|   .   
  -                          '(#MMH   ':,  .  
 :           '|                 'HMb_>/"||,.: 
.'                                '"'#&b   - .
:                                      ?|oHH?.
:                                        !MMM&
:  .                                  .  HMMMM
/.      -                               -MMMMM
|'.                                      9MMMP
:. .  . -                                |MMM'
 |... '                                  .MMT 
  &.                                    .dMP  
   |,                                  .HM*   
	|. '|.                            ,H&'    
	 '- '| -                        ,&':      
	   '.                         ,/| '       
		  '-..                  _.-           
			  "---.._|o,oov+--'"              
`,
`              _,d?,:?o?:?HM>#b|_             
		  ..H*"''''H#*"**MMMMMM6$$v_          
		v//"   - '      ''#MMMMMMMMHo.        
	  /"'                   |MMMMMMMMMM:.     
	,>                       'HMMMMMMMMH:.    
   :                           '#HMMMMHH| -   
  '                              'Z#MM,  ',:  
 :               '|                 ?HH_>:'|, 
:                                     "'*&| ':
.                                         <|Hb
:                                           MM
:                                        . iMM
Mb|.                                       {MM
::.'-       -                              !MP
'&.   .  .  -                              :M'
 9H,  |  '                                 |T 
  HM?                                     ,P  
   *ML                                   ??   
	:&.   'o                           .d'    
	  ':  |T                          /"      
		-.                         .<''       
		  '...                  ..-           
			  "'-=.,_,,,oov-~.-'              
`,
`            _,oc>?_:b?o?HH#b|_               
		  .v/99*""" '*H#""*HMMMMMZ,_          
		oH* /"   -   '      "'#MMMMM#o.       
	 ./*>-                     'MMMMMMMb      
	,b/'                        '#MMMMMMM|    
   :'                             'HMMMMb:    
  /-                                '|&MH '|  
 /                   '-.               |Hb??| 
,-  '                                    "'&,.
1                                           |}
!.                                           T
$,.                                        . 1
?'M??.                                       M
?.::| '|        -                            ?
 M?&.    .   .  -                           ,'
 9MMH|   ..  '           '                  . 
  HMMM#.                                   :' 
   9#MMb                                 ..   
	-:"#     'b.                        .-    
	  . '    {!                        /      
		-                           ,-'       
		  ' .                    .-           
			 '^==|_.,,,ov--|-'                
`,
`              _|o##??,:io??$#b|_             
		  .oH#"H9*""" "'#H*"*#MMMHo_          
		oHMM- -'    -  ''     '*HMMHo.        
	  dM#S>-'                     ?MMMM?.     
	,&&,/'                         "#MMMH|    
   d?-"                              '*HMMb   
  H?                                   "ZHb:  
 /:                        |              H?L 
|:|   .                                    '*:
:?:                                          |
>"                                           :
M||,_                                        |
!|":HH?-'.                                   :
:^'_:?"| '--         -                       .
- |ML?b      .   ..  -                       -
 :HMMMMH|    |               '              : 
  >MMMMMM#.                                .  
   ^M*HMMM|                               -   
	'. '"#+     '?v                     .'    
	  .   '-    +?'                    -      
	   ' .                          ..'       
		   - .                   .-           
			  "'|b=p?.._|vv---'               
`,
`              _,o#bH|??::?o?cbo_             
		  .o#MH#**SH""' "'*H#"*#MHo_          
		oHMMMH^  ^"    -  '      '*HHo.       
	 .dMMM#">>-                     'HM?.     
	,MH:R_o/                         '*MH|    
   dMM' '                               "ML   
  HMR! '                                 '#k  
 d&'.                          -.          'L 
:M ::     '                                 '-
/| !|                                        -
k.$-"                                        :
}9R:!,,_.                                    .
|::|':'*M#|-'.                               -
: "''..:"!'|  '-          -                  '
-   ,HMb.H|      .    _   -                 .'
 : ,MMMMMMMb.    ..                         . 
  .'HMMMMMMMM?                             .  
  '.'9M#*HMMMM                            :   
	-.'   "##*      'b,                  .    
	  .      '     ,/'                 .'     
	   ' .                          ..'       
		   - .                  ..-           
			  "'*#d##c.._|v----'              
`,
`              _,o#&oHb?|o::d?>|_             
		  .oHHMMM#**$M""' "'*HH"#&o_          
		oHMMMMMMD' .''    -  '    'bo.        
	 .dMMMMMH*'/|-                   '|b.     
	,MMMM?T|_o/                        '|     
   dMMMMP  ''                            '|   
  HMMMH& -                                '|  
 /MH7' :                          --        : 
-:MM  {.      .                              .
:i?' .!&                                     .
:{, o| '                                     :
-T?9M|:-'o,_                                 .
: |?::'"'?9MHo./..                           -
.  '"''^ _.'"!"^.  '-         -              '
-      ,bMM?.M|       .    .  -      .      .'
 :   .oMMMMMMMMb.    ..   '                 . 
  .  'HMMMMMMMMMMb                         -  
   -   9MH*#HMMMMH                        .'  
	'.  '   '"*##'      'b.              :    
	  .         '     .d''             .'     
		-.                          . '       
		   -.                    .-'          
			  "'*##H###:._|--.-'              
`,
`              _oo#H&d#b?|b:_>>|_             
		  .oHMMMMMMH*"*9R"'-'*#P|-_           
		oHMMMMMMMMM$  ."       '   '^-        
	 .dMMMMMMMMH*",?-                 '|.     
	,MMMMMMM:?}.,d'                     '.    
   dMMMMMMMH  /''                         :   
  HMMMMMMM&' -                             -  
 dPTMMP>' :                           -.    : 
|? -MM}  .|                                  .
J' ::*'  -$L                                 .
:  ?b .,H- '                                 :
-  |6.&MP:: !.,_.                            -
:   '|:: "' "':"MM#,-^,            -         :
-     ':' _.:"?'|   '-                   .    
:         .?bMML.]#        -   _  '      .  .'
 -      .o#MMMMMMMMH|     |.          .     . 
  -     'HMMMMMMMMMMMH                     :  
  '.     'HMM#*#MMMMMH'                   -   
	-.     '    '##*'      i+           :     
	  -            ''     v/'          .'     
	   '-                           ..'       
		  ' .                    .-           
			  "'*##HMH##:__,-.-'              
`,
`              _oo##Mbb&bo??o_>|_             
		  .oHMMMMMMMMM**#?M*' "?*&..          
		oHMMMMMMMMMMMM4  '"      -  '.        
	 .dMMMMMMMMMMMM#"|?.-              .      
	,MMMMMMMMMM}"9:_,d'                 -.    
   dMMMMMMMMMMM|  ^''                     .   
  &MMMMMMMMMMH|  -                         .  
 :{M*"MMMPT"' :                         '-. : 
.'M'  'MMM.  -T,       .                     .
- k   i:?''  -|&                             .
: '  -o&  .,H- "                             :
-     'M:'HMP|:'!.o._.                       .
:      "<:::'<^ '"'9MH#,-^ .                - 
-         ''''''._.'"?'^|   ^        -      : 
:              ?#dMM_.M?       .   .  -    ..'
 :          ,ddMMMMMMMMMb.    ..   '        . 
  .         TMMMMMMMMMMMMM,                :  
   -         ?MMH**#MMMMMH'               :   
	'.        '     "'##*'      &.       :    
	  -.               ''    ,~"       .'     
		-.                          ..'       
		  ' .                    .-           
			 '*##HMMMH#<:,..-'                
`,
`              _,dd#HMb&dHo?|?:|_             
		  .oHMMMMMMMMMMMH***9P''"|v.          
		oHMMMMMMMMMMMMMMM>  ''      -.        
	 .dMMMMMMMMMMMMMMMH*'|~-'          .      
	,MMMMMMMMMMMMM6>'H._,&              -.    
   dMMMMMMMMMMMMMMM|  '"                  .   
  H*MMMMMMMMMMMMMH&. -                     .  
 d' HMM""&MMMPT'' :.                      '.- 
,'  MP   'TMMM,   |:        .                -
|   #:    ? *"   : &L                        :
!   ''   /?H   ,#r ''                        :
.         ?M: HMM^<~->,o._                   :
:          '9:::''*-'':'9MHb,|-,         '  : 
.             '"''':' :_ ""!"^.  '|          :
'.                 _dbHM6_|H.      .   . '  .'
 |              _odHMMMMMMMMH,    ..  '     : 
 '-             |MMMMMMMMMMMMM|            :  
  '.             9MMH**#MMMMMH'           :   
	-.            '     "?##"      d     :    
	  .                    '    ,/"    .'     
	   '..                          ..'       
		  '  .                   .-           
			  ''"#HHMMMMM#<>..-'              
`,
`              _oo##bHMb&d#bd,>|_             
		  .oHMMMMMMMMMMMMMM***9R"-..          
		oHMMMMMMMMMMMMMMMMMH|  ?   '-.        
	 .dMMMMMMMMMMMMMMMMMMM#".}-'       .      
	,MMMMMMMMMMMMMMMMM6/'H _o}          -.    
   dMMMMMMMMMMMMMMMMMMML  '''             .   
  HbP*HMMMMMMMMMMMMMMM*: -                 ,  
 dMH' 'MMMP'"HMMMR'T"  :                    : 
|H'   -MR'   '?MMMb    P,       .            .
1&     *|     |.'*"  .-'&|                   .
M'      "    ||&|  .,#~ "'                   :
T             :HL.|HMH|c~'|v,|_              :
|              '"|:::':'-' '"MM#|-'.       -: 
%                 '''''' :_ '?''| '.      :   
||,                     ,#dMM?.M?      .  .' -
 ?|                 .,odMMMMMMMMM?    |  '  : 
  /                 |MMMMMMMMMMMMM:        .' 
  '.                 TMMH#*9MMMMM*        :   
	-.               '      "*#*'    ,:  .    
	  .                       '   .v'' .'     
	   '.                           ..'       
		  '- .                   .-           
			  "'|+HHMMMMMMHr~.-'              
`,
`              _,,>#b&HMHd&&bb>|_             
		  _oHMMMMMMMMMMMMMMMMH**H:.           
		oHMMMMMMMMMMMMMMMMMMMM#v'?  '.        
	 .dMMMMMMMMMMMMMMMMMMMMMMH*'+|     .      
	,MMMMMMMMMMMMMMMMMMMMMb|?+.,H       -.    
   ddHMMMMMMMMMMMMMMMMMMMMMb  ''          .   
  HMMkZ**HMMMMMMMMMMMMMMMMH|  -   .        :  
 dTMMM*  '9MMMP'"*MMMMPT"' ..               : 
|M6H''    4MP'   '"HMMM|   !|.      .        .
1MHp'      #L      $ *"'  .-:&.              .
MMM'        "     q:H.  .o#-''              : 
MM'                ?H?.|MMH::::-o,_.         -
M[                  '*?:::'|' '"':9MH|~-.    '
&M.                     ""'''^'.:.'?''. '|  -:
'M|d,                       .dbHM[.1?     .. :
 9||| .                  _obMMMMMMMMH,   .  : 
  H.^                    MMMMMMMMMMMM}     -  
   |                     |MMH#*HMMMMH'    .'  
	.                    '      '#*'   ,:-    
	 '                           '' .-'.      
	   '.                           .-        
		  '- .                   .-'          
			  ''|bqHMMMMMMHHb--'              
`,
`              .,:,#&6dHHHb&##o|_             
		  .oHHMMMMMMMMMMMMMMMMMH*|,.          
		oHMMMMMMMMMMMMMMMMMMMMMMHb:'-.        
	 .dMMMMMMMMMMMMMMMMMMMMMMMMMH||/'  .      
	,&HMMMMMMMMMMMMMMMMMMMMMMM/"&.,d.   -.    
   dboMMHMMMMMMMMMMMMMMMMMMMMMML ''       .   
  HMHMMM$Z***MMMMMMMMMMMMMMMMMM|.-         .  
 dMM}MMMM#'  '9MMMH?"'MMMMR'T'  _           : 
|MMMbM#''     |MM"    'MMMH.   <_           . 
dMMMM#&        *&.     .?'*"   .'&:          .
MMMMMH-         ''    -v/H   .dD "'  '       :
MMMM*                  '*M: 4MM*::-!v,_      :
MMMM                     '*?::" "''"?9Mb::. : 
&MMM,                       '"'"'|"._ "?'| - :
'MMM}.H                          ,#dM[_H   ..:
 9MMi'M: .                   .ooHMMMMMMM,  .. 
  9Mb '-                     1MMMMMMMMMM|  :  
   ?M                        |MM#*#MMMM*  .   
	-.                       '     |#"' ,'    
	  .                            -" v'      
		-.                          .-        
		   - .                   . '          
			  '-*#d#HHMMMMHH#"-'              
`,
`              _,<_:&S6dHHHb&bb|_             
		  .odHMMMMMMMMMMMMMMMMMMM}-_          
	   .oHMMMMMMMMMMMMMMMMMMMMMMMM#d:.        
	  ?9MMMMMMMMMMMMMMMMMMMMMMMMMMMH-$ .      
	,::dHMMMMMMMMMMMMMMMMMMMMMMMMH:|.?? -.    
   dMdboHMMHMMMMMMMMMMMMMMMMMMMMMMH, '    .   
  HMMMM7MMMb$R***MMMMMMMMMMMMMMMMMH| -     .  
 dMMMMM/MMMMM*   '$MMMM*'"*MMMM?&'  .       : 
|MMMMMMb1H*'       HMP'    '9MMM|   &.    .  .
dMMMMMMM##~'       '#|      |.'*"  .-9.      :
9MMMMMMMM*           '     |v7?  .,H '' '    :
SMMMMMMH'                   '9M_-MMH::-|v_   :
:HMMMMM                       '|_:"'|''':9Mv|.
-|MMMMM,                         ""'''':.'?| |
':MMMMM}.d}                         .?bM6,|  |
 :?MMM6  M|  .                   .,oHMMMMM| / 
  .?MMM- ''                      &MMMMMMMM|.  
   -'HM-                         HMH#*MMM?:   
	'.                           '   '#*:'    
	  -                              -'/      
	   ' .                          . '       
		  ' .                    . '          
			  '--##HH#HMMMHH#""'              
`,
`              _o,d_?dZdoHHHb#b|_             
		  .vdMMMMMMMMMMMMMMMMMMMMH|.          
	   .,HHMMMMMMMMMMMMMMMMMMMMMMMMH&,.       
	  /?RMMMMMMMMMMMMMMMMMMMMMMMMMMMMH|..     
	,|?>'T#RMMMMMMMMMMMMMMMMMMMMMMMM6'||/     
   dMMbd#ooHMMMHMMMMMMMMMMMMMMMMMMMMMH,'' '   
  HMMMMMMMTMMMMb$ZP**HMMMMMMMMMMMMMMMM|.   :  
 dMMMMMMMM}$MMMMMH'   'HMMMH?"'MMMM?T' .    : 
|MMMMMMMMMMoMH*''      'MM?    'MMM|  +|    . 
1MMMMMMMMMMMb#/         ?#?      |'#"  -T:   :
*'HMMMMMMMMMM*'           "     ~?&  .?} ' ' .
- 4MMMMMMMMP"                    'M? HMTc:|.: 
: 'MMMMMMM[                       "#:::'>'"?M{
.  |MMMMMMH.                        ''''_':-  
-  |MMMMMMM|.dD                         ,#Mb|'
 :  *MMMMM: iM|  .                   _oHMMMM: 
  .  ?MMMM'  "'                     ,MMMMMMP  
   :  'HMH                          JM#*MMT   
	-.  '                           '   #'    
	  .                                /      
		-.            -              .'       
		   -.                    . '          
			  '--=&&MH##HMHH#"""              
`,
`              .-:?,Z?:&$dHH##b|_             
		   ,:bqRMMMMMMMMMMMMMMMMMHo.          
		.?HHHMMMMMMMMMMMMMMMMMMMMMMMHo.       
	  -o/*M9MMMMMMMMMMMMMMMMMMMMMMMMMMMv      
	.:H|b|'|?#HHMMMMMMMMMMMMMMMMMMMMMM6?Z|    
   .?MMMHbdbbodMMMMHMMMMMMMMMMMMMMMMMMMM|':   
  :MMMMMMMMMMM7MMMMb?6P**#MMMMMMMMMMMMMMM_ :  
 |MMMMMMMMMMMMb^MMMMMM?   '*MMMM*"'MMMR<' . - 
.1MMMMMMMMMMMMMb]M#""       9MR'   '?MMb  |. :
-MMMMMMMMMMMMMMMH##|'        *&.     |'*' .| .
-?""*MMMMMMMMMMMMM'            '    |?b  ,}" :
:    MMMMMMMMMMH'                    'M_|M}r|?
.    'MMMMMMMMM'                      '$_:''"H
-     TMMMMMMMM,                        '"':: 
:     {MMMMMMMM| oH|                      .#M-
 :    '9MMMMMM' .MP   .                 ,oMMT 
  .     HMMMMP'  ''                    ,MMMP  
   -     'MMH'                         HH9*   
	'.    '                           ' .'    
	  -                               . '     
	   ' .               -          .-        
		  ' .                    .-           
			  ' -==pHMMH##HH#"""              
`];
	}

	init() {

		/*!
		  devtools-detect
		  Detect if DevTools is open
		  https://github.com/sindresorhus/devtools-detect
		  by Sindre Sorhus
		  MIT License
		*/

		let i = 0;
		let length = this.h.length;
		console.clear();
		console.log('%c' + this.role + ' : http://alfatih.world', 'border-bottom: 1px solid black; padding-right: ' + this.padding + 'px;color: #000 !important; font-family: "Times New Roman", "Times", serif, serif; font-size: 15px; font-style: normal; text-decoration: none;');
		console.log('%c ' + this.h[i], 'background: #8c8c8c; color: #ccc !important; font-family:monospace; font-size: 12px; font-style: normal;');

		let threshold = 160;
		let emitEvent = function (state, orientation) {
			window.dispatchEvent(new CustomEvent('devtoolschange', {
				detail: {
					open: state,
					orientation: orientation
				}
			}));
		};

		setInterval(() => {
			let widthThreshold = window.outerWidth - window.innerWidth > threshold;
			let heightThreshold = window.outerHeight - window.innerHeight > threshold;
			let orientation = widthThreshold ? 'vertical' : 'horizontal';

			if (!(heightThreshold && widthThreshold) &&
				((window.Firebug && window.Firebug.chrome && window.Firebug.chrome.isInitialized) || widthThreshold || heightThreshold)) {
				if (!this.devtools.open || this.devtools.orientation !== orientation) {
					emitEvent(true, orientation);
				}

				this.devtools.open = true;
				this.devtools.orientation = orientation;

				i = (i > length - 1) ? 0 : i;
				console.clear();
				console.log('%c' + this.role + ' : http://alfatih.world', 'border-bottom: 1px solid black; padding-right: ' + this.padding + 'px;color: #000 !important; font-family: "Times New Roman", "Times", serif, serif; font-size: 15px; font-style: normal; text-decoration: none;');
				console.log('%c ' + this.h[i], 'background: #8c8c8c; color: #ccc !important; font-family:monospace; font-size: 12px; font-style: normal;');
				i++;

			} else {
				if (this.devtools.open) {
					emitEvent(false, null);
				}

				this.devtools.open = false;
				this.devtools.orientation = null;

			}
		}, 500);

	}
}